import { Injectable } from "@angular/core";
import { RadioModel } from "../../../personal-data/model/radio.model";
import { DomainDataService } from "./domain-data.service";
import { CaronteResult } from "../../model/caronte-result";
import { DomainBrokerType } from "./model/domain-broker-type.model";
import { DomainDataType } from "./model/domain-data-type";
import { DomainUtil } from "./domain-util";
import { DomainOrigin } from "./model/domain-origin";
import { HandlerService } from "../comunicator-native/handler/handler";

@Injectable({
  providedIn: "root",
})
export class DomainDataCaronteBrokerService implements DomainDataService {
  readonly REL = "domain-root";
  readonly PARAM_NAME = "nome_dominio";
  readonly PARAM_ORIGEM = "id_origem";
  readonly PARAM_FILTRO = "filtro";

  private readonly domainTypes = [
    new DomainConvertionItem(
      DomainDataType.DocumentType,
      new DomainBrokerType("tipos_documento", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.City,
      new DomainBrokerType("cidades", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.Country,
      new DomainBrokerType("paises", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.Gender,
      new DomainBrokerType("generos", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.DocumentIssuing,
      new DomainBrokerType("emissores", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.MaritalStatus,
      new DomainBrokerType("estados_civis", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.OriginIncome,
      new DomainBrokerType("origens_renda", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.Profession,
      new DomainBrokerType("profissoes", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.State,
      new DomainBrokerType("estados", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.Nationality,
      new DomainBrokerType("nacionalidades", 1)
    ),
  ];

  constructor(private handlerService: HandlerService) {}

  public async getDomains(
    domainDataType: DomainDataType,
    parameter?: any
  ): Promise<RadioModel[]> {
    const dataCache = DomainUtil.getDomainFromCache(
      this.getOrigin(),
      domainDataType
    );

    if (dataCache && dataCache.length > 0) {
      return Promise.resolve(dataCache);
    } else {
      const domains = await this.getDataFromRemote(domainDataType, parameter);
      DomainUtil.saveDomainInCache(
        this.getOrigin(),
        domainDataType,
        domains,
        parameter
      );
      return Promise.resolve(domains);
    }
  }

  private async getDataFromRemote(
    domainDataType: DomainDataType,
    parameter?: any
  ): Promise<RadioModel[]> {
    const domainType = this.getDomainType(domainDataType);
    const parameters = new Map()
      .set(this.PARAM_NAME, domainType.name)
      .set(this.PARAM_ORIGEM, domainType.id_origem)
      .set(this.PARAM_FILTRO, parameter);

    return this.handlerService
      .caronteCommunicator(this.REL, null, parameters)
      .then((response: CaronteResult<any>) => {
        const domains: [] = response.data;

        if (domains) {
          switch (domainType.name) {
            case "tipos_documento":
              return Promise.resolve(domains.map(toDomainOtherModel));
            case "emissores":
              return Promise.resolve(domains.map(toDomainOtherModel));
            case "generos":
              return Promise.resolve(domains.map(toDomainGenderModel));
            default:
              return Promise.resolve(domains.map(toDomainModel));
          }
        } else {
          return Promise.resolve([]);
        }
      });
  }

  private getDomainType(domainTypeItem: DomainDataType): DomainBrokerType {
    return this.domainTypes.find((r) => r.domainDataType === domainTypeItem)
      ?.domainType;
  }

  getOrigin(): DomainOrigin {
    return DomainOrigin.BrokerCaronte;
  }
}

export class DomainConvertionItem {
  domainDataType: DomainDataType;
  domainType: DomainBrokerType;
  constructor(_domainDataType: DomainDataType, _domainType: DomainBrokerType) {
    this.domainDataType = _domainDataType;
    this.domainType = _domainType;
  }
}

function toDomainModel(item) {
  return new RadioModel(item.codigo, item.valor, item.valor);
}

function toDomainOtherModel(item) {
  return new RadioModel(
    item.codigo,
    item.campos_adicionais[0].sigla,
    item.campos_adicionais[0].sigla
  );
}

function toDomainGenderModel(item) {
  return new RadioModel(
    item.codigo,
    item.campos_adicionais[0].descricao,
    item.campos_adicionais[0].descricao
  );
}